// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"featuredproduct_imageContainer__14aUF"};